import axios from "axios";
import Config from "../utils/Config";

class SignatureSettingsService {
  config = {
    headers: {
      Authorization: "",
      CompanyId: "",
    },
  };

  //set access token
  setAccessToken(accessToken, companyId) {
    this.config.headers.Authorization = accessToken;
    this.config.headers.CompanyId = companyId;
  }

  //get esignature by user detail id
  async geteSignatureByUserDetailsId(userDetailsId, companyId, accessToken, signal) {
    this.setAccessToken(accessToken, companyId);

    const data = await axios.get(
      Config.BACKEND_URL + `/api/userDetails/signature/${userDetailsId}`, //userDetails/signature/663b56d49c935882d31a92d0
      {
        ...this.config,
        signal,
      }
    );
    return data.data;
  }

  //delete esignature data
  async deleteeSignature(userDetailsId, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);

    const data = await axios.delete(
      Config.BACKEND_URL + `/api/userDetails/deleteSignature`, ///userDetails/663b56d49c935882d31a92d0/deleteSignature
      this.config
    );
    return data.data;
  }

  //save esignature data
  async saveeSignature(formData, companyId, accessToken) {
    this.setAccessToken(accessToken, companyId);
    const config = {
      ...this.config,
      headers: {
        ...this.config.headers,        
      },
    };
    const data = await axios.patch(
      Config.BACKEND_URL + `/api/userDetails/uploadSignature/signature`, ///userDetails/663b56d49c935882d31a92d0/uploadSignature/signature
      formData,
      config
    );
    return data.data;
  }
};

export default new SignatureSettingsService();